import Resource from './common/resource';

class Notes extends Resource {
  path = 'notes';
}

export default Notes;
